/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Swap_End_OfflineInputs */

const en_us2_workout_swap_end_offline = /** @type {(inputs: Workout_Swap_End_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline: decide when you're back. Until then it's for today only.`)
};

const pt_br2_workout_swap_end_offline = /** @type {(inputs: Workout_Swap_End_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem conexão: decida quando voltar. Até lá, vale só para hoje.`)
};

const es_419_workout_swap_end_offline = /** @type {(inputs: Workout_Swap_End_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin conexión: decide cuando vuelvas. Hasta entonces, vale solo por hoy.`)
};

const pt_pt2_workout_swap_end_offline = /** @type {(inputs: Workout_Swap_End_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem ligação: decide quando voltares. Até lá, vale só para hoje.`)
};

const fr_fr2_workout_swap_end_offline = /** @type {(inputs: Workout_Swap_End_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hors ligne : décide à ton retour. D'ici là, ça vaut pour aujourd'hui seulement.`)
};

const de_de2_workout_swap_end_offline = /** @type {(inputs: Workout_Swap_End_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline: Entscheide, wenn du wieder online bist. Bis dahin gilt er nur für heute.`)
};

const it_it2_workout_swap_end_offline = /** @type {(inputs: Workout_Swap_End_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offline: decidi quando torni online. Fino ad allora vale solo per oggi.`)
};

/**
* | output |
* | --- |
* | "Offline: decide when you're back. Until then it's for today only." |
*
* @param {Workout_Swap_End_OfflineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_swap_end_offline = /** @type {((inputs?: Workout_Swap_End_OfflineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Swap_End_OfflineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_swap_end_offline(inputs)
	if (locale === "es-419") return es_419_workout_swap_end_offline(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_swap_end_offline(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_swap_end_offline(inputs)
	if (locale === "de-DE") return de_de2_workout_swap_end_offline(inputs)
	if (locale === "it-IT") return it_it2_workout_swap_end_offline(inputs)
	return en_us2_workout_swap_end_offline(inputs)
});
export { workout_swap_end_offline as "workout-swap.end_offline" }